import React, { useCallback } from "react";
import { connect } from "react-redux";

import { Company, Deal, Person } from "@mapmycustomers/shared/types/entity";

import { RootState } from "@app/store/rootReducer";

import Relationships from "../../components/Relationships";
import { DEALS_RELATIONSHIP_TYPES } from "../../enum/RelationshipType";
import {
  addDealParentCompany,
  addDealParentPerson,
  removeDealParentCompany,
  removeDealParentPerson,
} from "../store/actions";
import {
  getRemoveDealParentCompanyLoading,
  getRemoveDealParentPersonLoading,
  isAddDealParentCompanyLoading,
  isAddDealParentPersonLoading,
} from "../store/selectors";

interface Props {
  deal: Deal;
  parentCompany?: Company;
  parentPerson?: Person;
}

const RelationshipsContainer: React.FC<
  Props & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps>
> = ({
  addDealParentCompany,
  addDealParentCompanyLoading,
  addDealParentPerson,
  addDealParentPersonLoading,
  deal,
  parentCompany,
  parentPerson,
  removeDealParentCompany,
  removeDealParentPerson,
}) => {
  const handleRemoveParentCompany = useCallback(
    () => removeDealParentCompany(deal.id),
    [deal.id, removeDealParentCompany]
  );

  const handleSelectPeople = useCallback(
    (update: { peopleIds: Person["id"][] }) =>
      addDealParentPerson({ id: deal.id, parentPersonId: update.peopleIds[0] }),
    [deal.id, addDealParentPerson]
  );

  const handleRemovePeople = useCallback(
    () => removeDealParentPerson(deal.id),
    [deal.id, removeDealParentPerson]
  );

  return (
    <Relationships
      addParentCompanyLoading={addDealParentCompanyLoading}
      addPersonsLoading={addDealParentPersonLoading}
      entity={deal}
      onRemoveParentCompany={handleRemoveParentCompany}
      onRemovePeople={handleRemovePeople}
      onSelectParentCompany={addDealParentCompany}
      onSelectPeople={handleSelectPeople}
      parentCompany={parentCompany}
      people={parentPerson ? [parentPerson] : []}
      peopleMultiSelect={false}
      supportedRelationshipTypes={DEALS_RELATIONSHIP_TYPES}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  addDealParentCompanyLoading: isAddDealParentCompanyLoading(state),
  addDealParentPersonLoading: isAddDealParentPersonLoading(state),
  removeDealParentCompanyLoading: getRemoveDealParentCompanyLoading(state),
  removeDealParentPersonLoading: getRemoveDealParentPersonLoading(state),
});

const mapDispatchToProps = {
  addDealParentCompany: addDealParentCompany.request,
  addDealParentPerson: addDealParentPerson.request,
  removeDealParentCompany: removeDealParentCompany.request,
  removeDealParentPerson: removeDealParentPerson.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(RelationshipsContainer);
